module.exports = __webpack_public_path__ + "static/media/ic_outgoingCall.9ec32119.svg";